import { render, staticRenderFns } from "./DatasetVizSettings.vue?vue&type=template&id=5dbd244f&scoped=true&"
import script from "./DatasetVizSettings.vue?vue&type=script&lang=js&"
export * from "./DatasetVizSettings.vue?vue&type=script&lang=js&"
import style0 from "./DatasetVizSettings.vue?vue&type=style&index=0&id=5dbd244f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd244f",
  null
  
)

export default component.exports